// import ajax from '@/utils/ajax.js'
import { getAppInfo } from '../../api/user-api'
export default {
  namespaced: true,
  state: {
    appInfo: {}
  },
  getters: {
  },
  mutations: {
    setAppInfo(state, appInfo) {
      state.appInfo = appInfo
    }
  },
  actions: {
    async getAppInfo(ctx) {
      const res = await getAppInfo()
      const appList = res || []
      const miniapp = appList.filter(app => app.type === 'miniapp')
      const servicePackage = appList.filter(app => app.type === 'service_package')
      const standard = appList.filter(app => app.type === 'standard')

      ctx.commit('setAppInfo', {
        miniapp,
        standard,
        service_package: servicePackage
      })
    }
  }
}
